import getSessionContext from 'src/utils/context/getSessionContext'
import { make } from 'vuex-pathify'
import makeTableCommonActions from '../../utils/vuexModuleConstructor/vuexTableCommonActionsMaker'
import makeTableCommonGetters from '../../utils/vuexModuleConstructor/vuexTableCommonGettersMaker'
import makeTableCommonState from '../../utils/vuexModuleConstructor/vuexTableCommonStateMaker'

const remoteEntityName = 'controlled_actions.controlled_actions_tree'

const state = {
  ...makeTableCommonState()
}

const getters = {
  ...makeTableCommonGetters({ remoteEntityName }),

  pageTitle: () => 'Applicable controlled actions for the current app and org, in pre-tree form',

  controlledActions: () => {
    return { // 0 if anyone can. -1 if disabled (i.e., no one can); 'creator' -- if only user with id same as created_by_user_id
      create: -1,
      fetch: 46,
      update: -1,
      delete: -1,
      downloadList: -1,
      uploadList: -1
    }
  },

  controllerDefaultParams: (state, getters, rootState) => {
    return {
      fetch: { org_id: getSessionContext().org_id }
    }
  },

  columns: () => {
    return [
      { name: 'id', label: 'ID', style: 'width:50px', field: 'id' },
      { name: 'name', label: 'Name', field: 'name', align: 'left' },
      { name: 'parent_id', label: 'Parent ID', field: 'parent_id' },
      { name: 'description', label: 'Description', field: 'description', align: 'left' },
      { name: 'disabled', label: 'Disabled', field: 'disabled', isToggle: true }
    ]
  }
}

const mutations = make.mutations(state)
const namespaced = true

const actions = {
  ...makeTableCommonActions()
}

export default { state, actions, mutations, getters, namespaced }
